import { Flex, Space, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

type StepItemDetailProps = {
  title_long: string;
  description_long: JSX.Element | string;
  action?: JSX.Element | null;
  stepNumber: number;
  bottomAction?: JSX.Element;
};

export const StepItemDetail = ({
  title_long,
  description_long,
  action,
  stepNumber,
  bottomAction,
}: StepItemDetailProps) => {
  const { t } = useTranslation('waiting-screen');
  return (
    <Flex direction="column" my="10px" miw="300px" style={{ flex: 1 }}>
      <Text>
        {t('Step')} {stepNumber + 1}{' '}
      </Text>
      <Text size="21px" fw="700" lh="31px">
        {title_long}
      </Text>
      <Space h="sm" />
      {description_long}
      {action}
      {bottomAction}
    </Flex>
  );
};
